const a=async({signer:r,preapproval:p})=>r.requestPreapproval(p);var t=a;export{t as default};
